<template>
    <div class="main-header">
        <div>
            <span class="page-title">{{ pageTitle }}</span>
            <nav v-if="route.path !== '/admin/dashboard'" class="flex items-center gap-1">
                <span class="main-nav">Privacy Bee Admin</span>
                <span class="main-nav">/</span>
                <span class="main-nav !text-zinc-950">{{ pageTitle }}</span>
            </nav>
        </div>
        <div class="back">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                <path
                    d="M6.10547 9.5625L2.73047 6.1875L6.10547 2.8125"
                    stroke="#52525C"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M6.10547 14.0625H12.293C13.3373 14.0625 14.3388 13.6477 15.0772 12.9092C15.8156 12.1708 16.2305 11.1693 16.2305 10.125C16.2305 9.08071 15.8156 8.07919 15.0772 7.34077C14.3388 6.60234 13.3373 6.1875 12.293 6.1875H2.73047"
                    stroke="#52525C"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <div class="back-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16" fill="none">
                    <path d="M0.480469 6.90149V8.77142H10.9999V6.90149H0.480469Z" fill="#09090B" />
                    <path d="M3.00879 14.0947L5.6875 15.9647L5.73891 15.9998L8.46903 14.0947H3.00879Z" fill="#09090B" />
                    <path
                        d="M0.556641 10.4957C0.664612 11.1542 0.901119 11.7926 1.25074 12.3657H10.2277C10.5774 11.7926 10.8139 11.1592 10.9218 10.4957H0.556641Z"
                        fill="#09090B"
                    />
                    <path
                        d="M3.21465 3.70491C3.2198 2.37284 4.32521 1.2921 5.6877 1.2921C7.05019 1.2921 8.15561 2.37284 8.16075 3.70491V5.27826L9.47697 5.50949V3.70491C9.47697 1.65905 7.78028 0.00527082 5.6877 0.000244141C3.59512 0.00527082 1.90358 1.65905 1.89844 3.70491V5.52457L3.21465 5.29334V3.70491Z"
                        fill="#09090B"
                    />
                </svg>
                <span>Back to Hive</span>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const pageTitle = computed(() => {
    switch (route.path) {
        case '/admin/dashboard':
            return 'Dashboard';
        case '/admin/people':
            return 'People';
        case '/admin/companies':
            return 'Companies';
        case '/admin/operations':
            return 'Operations';
        case '/admin/finance':
            return 'Finance';
        case '/admin/research':
            return 'Threat Research';
        default:
            return 'Admin';
    }
});
</script>
<style scoped lang="scss">
.main-header {
    @apply flex items-center gap-2 self-stretch px-6 gap-3 h-28 border-b border-border-gray justify-between;

    .page-title {
        @apply flex flex-col gap-2 font-inter text-2xl font-bold leading-normal text-zinc-950;
    }

    .back {
        @apply flex justify-center items-center gap-3 p-2 rounded-md bg-zinc-200 cursor-pointer;

        &:hover {
            @apply bg-amber-400;
        }

        .back-title {
            @apply flex items-center gap-1.5;

            span {
                @apply flex items-center gap-1.5 text-xs font-medium font-inter leading-normal text-zinc-950;
            }
        }
    }
}
.main-nav {
    @apply text-zinc-600 font-inter text-xs font-medium leading-4;
}
</style>
